import axios from 'axios'
import store from '@/store/index.js'
import types from '@/constants/types'
import apiContext from '@/constants/apiContext'
import apiPermission from '@/constants/apiPermission'

import {
    Loading,
    MessageBox,
    Notification,
} from 'element-ui'; // 配置请求的默认值 iframe用?
import Common from "@/tools/helper.js"
// window.PUBLICHOSTA = 'http://192.168.1.150:9999';
window.PUBLICHOSTA = '';
// window.PUBLICHOSTA = 'http://192.168.1.150:8892';
window.CHANGEURLHOST = '';    // 专一网的地址
// window.PUBLICHOSTA = 'http://j1.chinazdap.com';
window.PUBLICPYTHON= '//p1.chinazdap.com';
window.FILEIP = 'http://f1.chinazdap.com'; //文件上传ip 
window.BaseUrlPrefix = window.PUBLICHOSTA;
//window.RASESLHOSTA = "//racesl.chinazdap.com"; //四流融合数字化教学做赛智慧平台
window.LastHOSt = "http://racesl.chinazdap.com";//四流融合数字化教学做赛智慧平台自主训练
window.RASESLHOSTA = "http://racesl.chinazdap.com"; //四流融合数字化教学做赛智慧平台
window.WS = "ws://ws1.chinazdap.com/ws";
window.WSS = "wss://ws1.chinazdap.com/ws"; // websocket 连接地址  https

// axios 配置|中断请求
window.cancelArr = [];
axios.defaults.timeout = 20000;
axios.defaults.baseURL = PUBLICHOSTA;
axios.defaults.headers['Content-Type'] = 'application/json';

axios.defaults.transformRequest = [function (data) {
    if (typeof data == 'object') {
        return JSON.stringify(data)
    } else if (typeof data == 'string' && data) {
        return JSON.parse(data);
    }
    return data || {};
}];

// http request 拦截器
// Loading 实例
let loadingIns;
axios.interceptors.request.use(
    config => {
        // config 设置CancelToken
        let CancelToken = axios.CancelToken;
        let source = CancelToken.source();
        window.cancelArr.push(source);
        config.cancelToken = source.token;

        //config 设置AccessToken
        if (sessionStorage.getItem('AccessToken')) {
            config.headers.token = sessionStorage.getItem('AccessToken')
        } else {
            let flag = false;
            for (let i = 0, len = apiPermission.length; i < len; i++) {
                let apiStr = apiPermission[i];
                if (config.url.indexOf(apiStr) > -1) {
                    flag = true;
                    break;
                }
            }
            if (!flag) source.cancel('无效的Token值！');
        }
        //禁用加载loading弹窗
        let isForbidLoading = false;
        for (let i = 0, len = apiContext.length; i < len; i++) {
            let apiStr = apiContext[i];
            if (config.url.indexOf(apiStr) > -1) {
                isForbidLoading = true;
                break;
            }
        }
        if (!isForbidLoading) {
            loadingIns = Loading.service({})
        }
        return config
    },
    err => {
        if (loadingIns)
            loadingIns.close()
        return Promise.reject(err)
    }
)
// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (loadingIns)
            loadingIns.close();
        let res = response.data;
        if (res) {
            res = Common.transToUpperCase(res);
            let entity = (typeof res.Entity == 'string' ? JSON.parse(res.Entity) : res.Entity) ||res;
            let code = entity.Code || entity.StatusCode;
            if (code === undefined) code = -1
            let message = entity.Msg || entity.ExceptionMessage;
            switch (code) {
                case -1:
                case 200:
                case 402:
                    return Promise.resolve(entity)
                case 401:
                    //中断请求
                    if (window.cancelArr && window.cancelArr.length) {
                        window.cancelArr.map(ct => {
                            ct.cancel('您已下线！');
                        });
                        window.cancelArr = [];
                    }
                    MessageBox(message, '提示', {
                        showClose: false,
                        confirmButtonText: '确定',
                    }).finally(() => {
                        store.commit(`students/${types.STUDENTS_LOGINOUT}`)
                    });
                    return Promise.reject(entity)
                default:
                    Notification.error({
                        title: "提示",
                        duration: 1000,
                        message: message,
                    });
                    return Promise.reject(entity)
            }
        } else {
            Notification.error({
                title: "错误",
                message: "错误码：" + res.StatusCode + " 错误信息：" + res.Message,
            });
            return Promise.reject(res)
        }
    },
    error => {
        if (loadingIns) loadingIns.close()
        let {
            code,
            message
        } = error;

        if (code === 'ECONNABORTED') {
            if (message === 'Network Error') {
                MessageBox({
                    title: '提示',
                    message: '网络异常，请稍候再试！',
                    type: 'info'
                })
            } else if (message.includes('timeout')) {
                MessageBox({
                    title: '提示',
                    message: '连接超时，请稍候再试！',
                    type: 'info'
                })
            }
        }
        return Promise.reject(error)
    }
)

export default axios


// WEBPACK FOOTER //
// ./src/api/fetch.js